import { MessageText } from "../../constants/constants.js";

const TEXT = MessageText.statusScreens.rescheduled;

export default function RescheduledScreen({
  sessionTitle = "this session",
  heading = TEXT.heading,
  noteLabel = TEXT.noteLabel,
  noteText = TEXT.noteText,
}) {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4 lg:p-8">
      <div className="max-w-md w-full text-center bg-white rounded-2xl shadow-xl p-10 border border-indigo-100">
        <div className="flex justify-center mb-8">
          <div className="w-20 h-20 rounded-full bg-indigo-50 flex items-center justify-center border-4 border-white shadow-inner">
            <svg className="w-10 h-10 text-indigo-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
              />
            </svg>
          </div>
        </div>

        <h2 className="text-2xl font-black text-gray-900 mb-3 tracking-tight">{heading}</h2>

        <p className="text-gray-500 text-sm mb-8 leading-relaxed">
          The session <span className="font-bold text-gray-800">"{sessionTitle}"</span> has
          been rescheduled to a new date. Please check back for updated timing.
        </p>

        <div className="bg-indigo-50 rounded-xl p-4 border border-indigo-100">
          <p className="text-indigo-800 text-xs font-semibold uppercase tracking-widest">{noteLabel}</p>
          <p className="text-indigo-700 text-sm mt-1">{noteText}</p>
        </div>
      </div>
    </div>
  );
}
